import iconInvest from 'assets/img/dashboard/home/img/icon-activity.svg';
import iconCard from 'assets/img/dashboard/buy-and-sell/img/icon-card.svg';
import iconBank from 'assets/img/dashboard/buy-and-sell/img/icon-bank.svg';
import iconLeave from 'assets/img/dashboard/buy-and-sell/img/icon-leave.svg';
import iconWallet from 'assets/img/dashboard/buy-and-sell/img/icon-wallet.svg';

export const images = {
    invest: iconInvest,
    card: iconCard,
    bank: iconBank,
    leave: iconLeave,
    wallet: iconWallet,
};
